import { render, staticRenderFns } from "./ProSelect.vue?vue&type=template&id=258f6108&scoped=true"
import script from "./ProSelect.vue?vue&type=script&lang=js"
export * from "./ProSelect.vue?vue&type=script&lang=js"
import style0 from "./ProSelect.vue?vue&type=style&index=0&id=258f6108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f6108",
  null
  
)

export default component.exports